import { WorkflowItem } from "./workflow-item.model";

export class WorkflowItemWrapper {     
    $type: string;
    $values: WorkflowItem[] = [];
    
    constructor(type: string, values: WorkflowItem[]) {
        this.$type = type;
        this.$values = values;                
    }

}



